import _ from 'lodash';
import { Col, Row } from 'antd';
import React from 'react';

const PartRow = ({ narrow, active, children }) => (
  <div className={active ? 'query-part query-part-active' : 'query-part'}>
    {active ? (
      <div>
        {React.Children.toArray(children).slice(1)}
        <div className="query-label query-label-active">{_.first(children)}</div>
      </div>
      ) : (
        <Row gutter={8} type="flex" justify="center" align="middle">
          <Col xs={24} sm={4} md={6} xl={narrow ? 12 : 4}>
            <div className="query-label"> {children[0]}</div>
          </Col>
          <Col xs={24} sm={20} md={18} xl={narrow ? 12 : (24 - 4)}>
            {_.last(children)}
          </Col>
        </Row>
    )}
  </div>
);

export default PartRow;
